module.exports = "<div class=\"envelope\">\r\n    <div>\r\n        <div class=\"form-group envelope__title\">\r\n            <h1>{{homePageTitle}}</h1>\r\n            <p>{{homeDescription}}</p>\r\n        </div>\r\n\r\n        <ul>\r\n            <li>{{homeList1}}</li>\r\n            <li>{{homeList2}}</li>\r\n            <li>{{homeList3}}</li>\r\n        </ul>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/templates/common/homeView.component.html
// module id = 460
// module chunks = 0